import { PhomeNumberFormGroupValue } from "components/forms/PhoneNumberFormGroup";

export const mapPhoneNumberFormGroupValueToString = (
  value: PhomeNumberFormGroupValue
): string => `+${value.prefix}${value.number}`;
